// types
import { ILocation } from './types'
// components
import { GoogleMap } from '../../../components/Map';
import { TMarker } from '../../../components/Map/Map';

export interface ILocationProps {
    width? : string,
    height?: string,
    latitude: number;
    longitude: number;
    title: string;
}

export function OperatorPanel(props: ILocationProps) {

    const markers: TMarker[] = [{ latitude: props.latitude, longitude: props.longitude, title: props.title }];
    return (
            <GoogleMap width={props.width || '100%'} height={props.height || '300px'} markers={markers}   ></GoogleMap>
    );
}
